import React from "react";
import ReactDOM from "react-dom";
import { Video } from "../components/Video";
import { useI18n } from "../domain/i18n";

/**
 * This hook locates all elments what have a `data-video` attribute
 * and initiaizes the <Video> component in those places.
 */
export function useVideo() {
  const I18n = useI18n();
  React.useEffect(() => {
    Array.from(document.querySelectorAll("[data-video]")).forEach((el) => {
      const { id, title } = (el as HTMLElement).dataset;
      if (id && title) {
        ReactDOM.render(React.createElement(Video, { I18n, id, title, aspectRatio: 16 / 9 }), el);
      }
    });
  }, [I18n]);
}
